export const DASHBOARD = 'dashboard';
export const TOOLS = 'tools';
export const PACKAGES = 'packages';
export const TEAMS = 'teams';
export const MEMBERS = 'members';
export const STACKS = 'stacks';
export const ACTIVITIES = 'activities';
export const VULNERABILITY = 'vulnerabilities';
export const TECH_RADAR = 'technology-radar';
